module.exports = __webpack_public_path__ + "static/transparency_award-6baa24c07817d0d78ca6f82051f8ee03.jpg";